import "../../styles/index.css";
import { Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const ProgressBar = ({ progress, onCancel }) => {
  return (
    <Box className="progress-line">
      <Box
        className="progress-line-left"
        style={{ width: `${progress}%` }}
      ></Box>

      <Box
        className="progress-line-right"
        style={{ width: `${100 - progress}%` }}
      ></Box>

      <Box className="cancel-icon">
        <IconButton onClick={onCancel}>
          <CloseIcon />
        </IconButton>
      </Box>
    </Box>
  );
};
export default ProgressBar;
